import apiClient from './api';

// 8 sep 2026 (pedido de Augusto: "los informes aparecen en dolares,
// deberia dar la opcion de dolares o soles, pero siempre mostrarlo en la
// moneda de donde es el usuario"): cada metodo ahora manda `moneda`
// ('PEN' o 'USD') y, si el usuario sobreescribio la tasa a mano, tambien
// `tasa_manual` -- ver Reports.js (useReportCurrency) y el backend
// (reports.py::_resolver_conversion). getBudgetReport queda igual, sin
// parametro de moneda: el presupuesto vive solo en soles por diseno
// (mismo criterio que Budgets.js), nunca se convierte.
const conMoneda = (moneda, tasaManual) => ({
  moneda,
  ...(tasaManual ? { tasa_manual: tasaManual } : {}),
});

const reportService = {
  getMonthlyReport: async (year, month, moneda, tasaManual) =>
    apiClient.get('/reports/monthly', { params: { year, month, ...conMoneda(moneda, tasaManual) } }),
  getYearlyReport: async (year, moneda, tasaManual) =>
    apiClient.get('/reports/yearly', { params: { year, ...conMoneda(moneda, tasaManual) } }),
  // 8 sep 2026 (Augusto: "no he gastado S/. 37,696 en educacion en
  // Setiembre 2026" -- el backend sumaba TODO el historial de la
  // categoria sin filtrar por fecha; "todo reporte tiene que ir de
  // acuerdo a los filtros"): ahora exigen year/month, igual que
  // getMonthlyReport.
  getCategoryReport: async (category, year, month, moneda, tasaManual) =>
    apiClient.get(`/reports/category/${category}`, { params: { year, month, ...conMoneda(moneda, tasaManual) } }),
  getSpendingPattern: async (year, month, moneda, tasaManual) =>
    apiClient.get('/reports/spending-pattern', { params: { year, month, ...conMoneda(moneda, tasaManual) } }),
  getBudgetReport: async () => apiClient.get('/reports/budget'),
  getDebtReport: async (moneda, tasaManual) =>
    apiClient.get('/reports/debt', { params: { ...conMoneda(moneda, tasaManual) } }),
  // 11 ago 2026: reporte narrativo real con IA (Claude), ver
  // backend_new/app/api/v1/endpoints/reports.py -- antes "reportes
  // inteligentes con IA" se vendía en el plan Pro sin existir de verdad.
  getAiSummary: async (year, month, moneda, tasaManual) =>
    apiClient.get('/reports/ai-summary', { params: { year, month, ...conMoneda(moneda, tasaManual) } }),
  // 28 ago 2026: tendencia automática de ahorro/deuda para el Panel (sin
  // metas manuales, ver backend_new/.../reports.py trend_report).
  getTrend: async (months = 6, moneda, tasaManual) =>
    apiClient.get('/reports/trend', { params: { months, ...conMoneda(moneda, tasaManual) } }),
};

export default reportService;
